import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const CheckboxChecked = createSvgIcon(
  <path d="M24 0H0V24H24V0ZM9.59998 19.3456L2.25439 12L4.79998 9.45441L9.59998 14.2544L19.2 4.65441L21.7456 7.2L9.59998 19.3456Z" />,
  'CheckboxChecked'
);

export { CheckboxChecked };